/**
 * @file
 * A JavaScript file containing the main menu functionality (small/large screen)
 *
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:
// - https://drupal.org/node/1446420
// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth

(function (Drupal, $) {
  Drupal.behaviors.print = {
    attach: function (context) {

      $(once('print-page', '.print-page a')).on('click', function(e) {
        e.preventDefault();

        function sleep(waitSec, callbackFunc) {
          var spanedSec = 0;
          var waitFunc = function () {
              spanedSec++;
              if (spanedSec >= waitSec) {
                  if (callbackFunc) callbackFunc();
                  return;
              }
        
              clearTimeout(id);
              id = setTimeout(waitFunc, 1000);
          };
          var id = setTimeout(waitFunc, 1000);
        }
        
        function unveilAndPrint() {
          var ctr = 0;
          if($('img.lazyload').length) {
            document.querySelectorAll('img.lazyload').forEach(function(v, k, array) {
              lazySizes.loader.unveil(v);
              ctr++;
              if (ctr === array.length) {
                sleep(1, function() {
                  window.print();
                  ctr = 0;
                });
              }
            });
          }
          else {
            window.print();
          }
        }
        unveilAndPrint();
      })
    },
  };
})(Drupal, jQuery);
